import assetPath from '/app/packages/startpage-logged-out/native-apps-section/src/assets/illustration-native-app-section.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')